const skillsData = {
  'Frontend Development': [
    { skillClass: 'p25', skillPercent: '25', skillName: 'HTML' },
    { skillClass: 'p70', skillPercent: '70', skillName: 'CSS' },
    { skillClass: 'p50', skillPercent: '50', skillName: 'JQUERY' },
    { skillClass: 'p89', skillPercent: '89', skillName: 'JAVASCRIPT' },
    { skillClass: 'p89', skillPercent: '89', skillName: 'TYPESCRIPT' },
    { skillClass: 'p65', skillPercent: '65', skillName: 'NEXTJS' },
    { skillClass: 'p45', skillPercent: '45', skillName: 'REACTJS' },
    { skillClass: 'p80', skillPercent: '80', skillName: 'REDUX' },
    { skillClass: 'p45', skillPercent: '45', skillName: 'GSAP' },
    { skillClass: 'p45', skillPercent: '45', skillName: 'FRAMER MOTION' },
  ],
  'Backend Development': [
    { skillClass: 'p89', skillPercent: '89', skillName: 'NODEJS' },
    { skillClass: 'p89', skillPercent: '89', skillName: 'PYTHON' },
    { skillClass: 'p45', skillPercent: '45', skillName: 'EXPRESSJS' },
    { skillClass: 'p80', skillPercent: '80', skillName: 'REST APIS' },
    { skillClass: 'p80', skillPercent: '80', skillName: 'WEBSOCKETS' },
    { skillClass: 'p80', skillPercent: '80', skillName: 'SERVERLESS' },
    { skillClass: 'p80', skillPercent: '80', skillName: 'SSR & SSG' },
  ],
  'Database & Storage': [
    { skillClass: 'p80', skillPercent: '80', skillName: 'MONGODB' },
    { skillClass: 'p80', skillPercent: '80', skillName: 'GRAPHQL' },
    { skillClass: 'p80', skillPercent: '80', skillName: 'POSTGRESQL' },
    { skillClass: 'p80', skillPercent: '80', skillName: 'FIREBASE' },
  ],
  'Cloud & Hosting': [
    { skillClass: 'p80', skillPercent: '80', skillName: 'GOOGLE CLOUD' },
    { skillClass: 'p80', skillPercent: '80', skillName: 'AWS' },
    { skillClass: 'p80', skillPercent: '80', skillName: 'VERCEL' },
    { skillClass: 'p80', skillPercent: '80', skillName: 'NETLIFY' },
    { skillClass: 'p80', skillPercent: '80', skillName: 'RENDER' },
  ],
  'CMS & Website Builders': [
    { skillClass: 'p95', skillPercent: '95', skillName: 'WIX' },
    { skillClass: 'p89', skillPercent: '89', skillName: 'VELO(WIX)' },
    { skillClass: 'p80', skillPercent: '80', skillName: 'WORDPRESS' },
  ],
  'Tools & Version Control': [
    { skillClass: 'p80', skillPercent: '80', skillName: 'GITHUB' },
    { skillClass: 'p75', skillPercent: '75', skillName: 'GIT' },
    { skillClass: 'p70', skillPercent: '70', skillName: 'VS CODE' },
    { skillClass: 'p70', skillPercent: '70', skillName: 'CURSOR' },
    { skillClass: 'p65', skillPercent: '65', skillName: 'POSTMAN' },
    { skillClass: 'p60', skillPercent: '60', skillName: 'NPM/YARN' },
    { skillClass: 'p70', skillPercent: '70', skillName: 'WEBPACK' },
    { skillClass: 'p65', skillPercent: '65', skillName: 'VITE' },
  ],
};

const Skills = () => {
  return (
    <div className="skills-container">
      {Object.entries(skillsData).map(([category, skills]) => (
        <div key={category} className="skill-category mb-5">
          <h4 className="category-title text-center mb-4 text-uppercase">
            {category}
          </h4>
          <div className="row">
            {skills.map((val, i) => (
              <div className="col-6 col-md-3 mb-3 mb-sm-5" key={i}>
                <div className={`c100 ${val.skillClass}`}>
                  <span>{val.skillPercent}%</span>
                  <div className="slice">
                    <div className="bar"></div>
                    <div className="fill"></div>
                  </div>
                </div>
                <h6 className="text-uppercase open-sans-font text-center mt-2 mt-sm-4">
                  {val.skillName}
                </h6>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Skills;
